// extracted by mini-css-extract-plugin
export default {"formWrapper":"FormLayout_formWrapper__HBLJn","mobileButtons":"FormLayout_mobileButtons__+s9NY","desktopButtons":"FormLayout_desktopButtons__vIhN5"};